import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeProject(project: Boundaries["removeProject"]["request"]): void;
}

function useProjectRemoval(project: Identifiable<Project>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveProjectRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveProjectRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveProjectRequestFailure(project),
    ),
    removeProject: core.removeProject,
  };
}

export { useProjectRemoval };
